export function programHasMappedProjects(program) {
  return Array.isArray(program?.project) &&
    program.project.some(project => project && project.projectId);
}

/** Programs that should appear as checkboxes on the overall map "Our Projects" tab. */
export function getOverallMapProjectPrograms(programs) {
  if(!programs?.length) return [];
  return programs.filter(item => item.slug && item.title && programHasMappedProjects(item));
}

/** ArcGIS project ids for all programs shown on the overall map projects tab. */
export function getOverallMapProjectIds(programs) {
  const projectIds = [];
  getOverallMapProjectPrograms(programs).forEach(program => {
    (program.project || []).forEach(project => {
      if(project && project.projectId){
        projectIds.push(project.projectId);
      }
    });
  });
  return projectIds;
}

function projectIdsForProgram(program) {
  return (program.project || [])
    .filter(project => project && project.projectId)
    .map(project => project.projectId);
}

/**
 * Which project polygons to draw for the overall-map Our Projects checkboxes.
 * `drawAll: true` means skip the ArcGIS `project_id IN (...)` filter — listing
 * every id makes FeatureLayer tile GETs so long they fail and can lock the tab.
 */
export function getOverallMapProjectDrawPlan(programs, layerChecks) {
  const mapped = getOverallMapProjectPrograms(programs);
  if(mapped.length === 0){
    return {drawAll: false, ids: []};
  }

  const checks = layerChecks && typeof layerChecks === 'object' ? layerChecks : {};
  const checked = mapped.filter(program => checks[program.slug] !== false);
  if(checked.length === 0){
    return {drawAll: false, ids: []};
  }
  if(checked.length === mapped.length){
    return {drawAll: true, ids: []};
  }

  const ids = [];
  checked.forEach(program => {
    ids.push(...projectIdsForProgram(program));
  });
  return {drawAll: false, ids};
}
